import React from 'react';
import PropTypes from 'prop-types';

import { PrimaryButton } from '../../..';
import { GREEN_LIGHT, ORANGE, WHITE } from '../../../styles/shared/colors';

const ButtonsPanel = ({ usersCount, onAdd, onInvite, inviteButtonText })=> {
  return (
    <div className="add-player-to-team__buttons-panel">
      <PrimaryButton 
        color={WHITE} background={GREEN_LIGHT}
        style={{ width: "60%" }}
        onClick={onInvite}
      >
        <span style={{ padding: "0px 10px", fontSize: "20px" }}>+</span>
        <span>{inviteButtonText}</span>
      </PrimaryButton>
      <PrimaryButton 
        color={WHITE} 
        background={ORANGE}
        style={{ width: "40%" }}
        onClick={onAdd}
      >
        <span>Add</span>        
        <span>({usersCount})</span>        
      </PrimaryButton>
    </div>
  );
};

ButtonsPanel.propTypes = {
  onAdd: PropTypes.func,
  onInvite: PropTypes.func,  
  usersCount: PropTypes.number
};

ButtonsPanel.defaultProps = {
  onAdd: ()=> {},
  onInvite: ()=> {}, 
  usersCount: 0
}; 

export default ButtonsPanel;